import script from "./vehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./vehicle.vue?vue&type=script&setup=true&lang=js"

import "./vehicle.vue?vue&type=style&index=0&id=19f4a5ef&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19f4a5ef"]])

export default __exports__